import React, { useMemo } from "react";

function isBlankHtml(html) {
  const plain = String(html || "")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();
  return !plain;
}

/**
 * Preview del correo que reciben los suscriptores (misma estructura que SES).
 */
export default function RevistaEmailPreview({
  title = "Conexión Siete",
  messageHtml = "",
  subscriberName = "Ana",
}) {
  const body = useMemo(() => {
    if (isBlankHtml(messageHtml)) {
      return (
        <p className="text-[#555] m-0">
          Ya puedes leer <strong>{title}</strong> en el lector de Conexión Siete:
        </p>
      );
    }
    return (
      <div
        className="text-[#333] leading-relaxed [&_a]:text-[#7c6ba8] [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5"
        dangerouslySetInnerHTML={{ __html: messageHtml }}
      />
    );
  }, [messageHtml, title]);

  return (
    <div className="rounded-xl border border-brand-lavender/20 bg-[#f4f3f8] overflow-hidden h-full flex flex-col min-h-[280px]">
      <div className="px-3 py-2 border-b border-brand-lavender/15 bg-white/70">
        <p className="text-xs font-semibold text-brand-dark">Vista previa del correo</p>
        <p className="text-[11px] text-brand-gray mt-0.5">Así lo verán los suscriptores</p>
      </div>
      <div className="flex-1 overflow-y-auto p-3 sm:p-4">
        <div
          className="mx-auto max-w-[360px] bg-white rounded-lg shadow-sm border border-black/5 p-5 text-left"
          style={{ fontFamily: "Arial, sans-serif" }}
        >
          <h2 className="text-[#41446d] text-base font-semibold m-0 mb-2">
            Conexión Siete
          </h2>
          <p className="text-[#333] text-sm m-0 mb-3">Hola {subscriberName},</p>
          <div className="text-sm mb-4">{body}</div>
          <p className="my-5">
            <span className="inline-block bg-[#7c6ba8] text-white text-sm font-semibold px-4 py-2.5 rounded-lg">
              Leer Conexión Siete
            </span>
          </p>
          <p className="text-[12px] text-[#555] m-0">
            También puedes{" "}
            <span className="text-[#7c6ba8] underline">descargar el PDF</span>.
          </p>
          <p className="mt-5 mb-0 text-sm text-[#41446d]">— EAP Consulting</p>
        </div>
      </div>
    </div>
  );
}
